import classNames from 'classnames';
import React, { ReactNode } from 'react';

import { createStyles } from '../../../utils/createStyle';

export interface FieldContainerProps {
    label: ReactNode;
    footer?: ReactNode;
    error?: string;
    id?: string;
    className?: string;
    controlClassName?: string;
    required?: boolean;
}

const styles = createStyles({
    container: [
        'w-full rounded-t',
        {
            backgroundColor: '#F7F7F7',
        },
    ],
    title: ['text-xs px-2 font-bold'],
    control: ['border-b border-grey-2'],
    footer: [
        'grid text-center text-xs gap-2',
        {
            gridTemplateColumns: 'max-content max-content max-content',
        },
    ],
});

export const FieldContainer = ({
    label,
    footer,
    error,
    children,
    className,
    controlClassName,
    required,
}: React.PropsWithChildren<FieldContainerProps>) => {
    return (
        <div className={className}>
            <div className={classNames(styles.container, error ? 'text-error' : 'text-brand')}>
                <div className={styles.title}>
                    {required && <span className="text-brand-accent">* </span>}
                    {label}
                </div>
                <div className={classNames(styles.control, controlClassName)}>{children}</div>
            </div>
            {footer && <div className={styles.footer}>{footer}</div>}
            {error && <div className="text-error text-xs pt-1">{error}</div>}
        </div>
    );
};
